import {cooperativeBreedInterface} from "./cooperativeConst";

const {ccclass, property} = cc._decorator;

@ccclass
export default class CooperativeBreedItem extends cc.Component {

    @property({type:cc.Label,displayName:"名字文本"})
    lb_Name:cc.Label = null;

    @property({type:cc.Label,displayName:"描述文本"})
    lb_Explain:cc.Label = null;

    data:cooperativeBreedInterface = null;

    selectFun:(node:cc.Node)=>void;

    bindData(data:cooperativeBreedInterface,selectFun:(node:cc.Node)=>void){
        this.data = data;
        this.selectFun = selectFun;
        this.updateItem();
    }

    onBtnContact(){
        this.selectFun && this.selectFun(this.node);
    }

    updateItem(){
        this.lb_Name.string = this.data.name;
        this.lb_Explain.string = this.data.explain;
    }
}
